import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitEnquiry = (payload) => axios.post(`${API}/enquiries`, payload);
